import { appConfig } from '../../packages/web/src/models/app'
import { convertPageType } from './convertPageType'

export const getRecommenderData = componentSetting => {
  const { container: componentId, layout, tabs } = componentSetting
  const engineKey = String(componentId).replace('--viewed', '')
  const engine = appConfig.engines[engineKey]
  const { id, pageType, route } = engine
  const validRecommender = typeof id === 'number'

  if (!validRecommender) return null

  return {
    id,
    engine: tabs ? tabs[0].engine : null,
    pageType: convertPageType(pageType),
    layout,
    pathname: route
      ? typeof route === 'string'
        ? route
        : route.toString().slice(1, -1)
      : ''
  }
}
